import { defaultEnv } from './default.app';
import { AppConfig } from './config.app';

export const environment: AppConfig = {
  ...defaultEnv,
  production: false,
};
